import { createContext, useCallback, useContext, useState } from "react";

type LastTimeNewOrdersCheckedContextType = {
  lastChecked: Date;
  setLastChecked: (date: Date) => void;
};

const LastTimeNewOrdersCheckedContext = createContext<
  LastTimeNewOrdersCheckedContextType | undefined
>(undefined);

export const LastTimeNewOrdersCheckedProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const getDefaultLastChecked = () => {
    const dateFetched = new Date(
      localStorage.getItem("lastTimeNewOrdersChecked") ?? 0,
    );
    return Number.isNaN(dateFetched.getTime()) ? new Date(0) : dateFetched;
  };

  const [innerLastChecked, setInnerLastChecked] = useState<Date>(
    getDefaultLastChecked,
  );

  const setLastChecked = useCallback((date: Date) => {
    localStorage.setItem("lastTimeNewOrdersChecked", date.toISOString());
    setInnerLastChecked(date);
  }, []);

  return (
    <LastTimeNewOrdersCheckedContext.Provider
      value={{ lastChecked: innerLastChecked, setLastChecked }}
    >
      {children}
    </LastTimeNewOrdersCheckedContext.Provider>
  );
};

export const useLastTimeNewOrdersChecked =
  (): LastTimeNewOrdersCheckedContextType => {
    const context = useContext(LastTimeNewOrdersCheckedContext);
    if (!context) {
      throw new Error(
        "useLastTimeNewOrdersChecked doit être utilisé dans un LastTimeNewOrdersCheckedProvider",
      );
    }
    return context;
  };
